import React, { ReactElement } from 'react';
import { Modal } from 'antd';
import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import { onboardingStyles } from './OnboardingModal.styles';

interface OnboardingModalProps {
  open: boolean;
  onClose: () => void;
  image: string;
  content: ReactElement;
  title: string;
  buttonText?: string;
  secondButtonText?: string;
  onButtonClick?: () => void;
  onSecondButtonClick?: () => void;
  isVideo?: boolean;
  badge?: string;
}

const OnboardingModal: React.FC<OnboardingModalProps> = ({
  open,
  onClose,
  image,
  buttonText = 'Get Started',
  secondButtonText = '',
  content,
  title,
  onButtonClick,
  onSecondButtonClick,
  isVideo = false,
  badge,
}) => {
  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose();
  };

    const handleSecondButtonClick = () => {
    if (onSecondButtonClick) {
      onSecondButtonClick();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      className={onboardingStyles.modal}
      closeIcon={<CloseOutlined />}>
      <div className={onboardingStyles.container}>
        <div className={onboardingStyles.imageSection}>
          <img
            src={image}
            alt="Onboarding"
            className={isVideo ? onboardingStyles.video : onboardingStyles.image}
          />
        </div>

        <div className={onboardingStyles.contentSection}>
          <div className={onboardingStyles.header}>
            {badge && <div className={onboardingStyles.badge}>{badge}</div>}
            <h1 className={onboardingStyles.title}>{title}</h1>
          </div>

          <div className={onboardingStyles.content}>{content}</div>

          <div className={onboardingStyles.buttonContainer}>
            <button className={onboardingStyles.nextButton} onClick={handleButtonClick}>
              {buttonText}
              <ArrowRightOutlined />
            </button>
            {secondButtonText && (
              <button className={onboardingStyles.nextButton} onClick={handleSecondButtonClick}>
                {secondButtonText}
                <ArrowRightOutlined />
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OnboardingModal;
